var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "179px",
    height: "156px",
    viewBox: "0 0 179 156",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2E3A52D3-8C20-4CC6-BEEE-3B0F89B0D33E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-19.5%",
    y: "-23.5%",
    width: "139.7%",
    height: "147.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.156277316 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-number",
    transform: "translate(-100.000000, -212.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smart-key",
    filter: "url(#filter-1)",
    transform: "translate(120.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.38390702,21.4507759 L0,23.9478504 L0,96.1380449 C0,100.901819 3.85507316,104.763565 8.61061712,104.763565 L129.591137,104.763565 C134.346681,104.763565 138.201754,100.901819 138.201754,96.1380449 L138.201754,23.9478504 L136.817847,21.4507759 L1.38390702,21.4507759 Z",
    id: "Path",
    fill: "#D7D9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.102206,21.4507759 L124.102206,82.0140939 C124.102206,86.7778685 120.247133,90.6396139 115.491589,90.6396139 L0,90.6396139 L0,96.1380449 C0,100.901819 3.85507316,104.763565 8.61061712,104.763565 L129.591137,104.763565 C134.346681,104.763565 138.201754,100.901819 138.201754,96.1380449 L138.201754,23.9478504 L136.817847,21.4507759 L124.102206,21.4507759 Z",
    id: "Path",
    fill: "#CDCFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.591137,0.143578405 L8.61061712,0.143578405 C3.85507316,0.143578405 9.58967311e-15,4.00532375 9.58967311e-15,8.76909839 L9.58967311e-15,23.9478504 L138.201754,23.9478504 L138.201754,8.76909839 C138.201754,4.00532375 134.346681,0.143578405 129.591137,0.143578405 Z",
    id: "Path",
    fill: "#3F4CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.591137,0.143578405 L124.102206,0.143578405 L124.102206,23.9478504 L138.201754,23.9478504 L138.201754,8.76909839 C138.201754,4.00532375 134.346681,0.143578405 129.591137,0.143578405 Z",
    id: "Path",
    fill: "#192783"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.606788, 8.111774)",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFA698",
    cx: 3.99030573,
    cy: 3.93394013,
    rx: 3.86317092,
    ry: 3.86985712
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFE07D",
    cx: 15.8740371,
    cy: 3.93394013,
    rx: 3.86317092,
    ry: 3.86985712
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#86F1A7",
    cx: 27.7577684,
    cy: 3.93394013,
    rx: 3.86317092,
    ry: 3.86985712
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.105263, 36.315789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9004233,45.1549874 C48.8151408,45.1549874 49.4481614,44.2345887 49.1558345,43.3478963 C46.3627837,34.8710408 38.5313455,28.765041 29.3017874,28.765041 L20.0823279,28.765041 C10.8527698,28.765041 3.02159734,34.870769 0.228280749,43.3478963 C-0.0637804188,44.2343169 0.569240238,45.1549874 1.48369199,45.1549874 L47.9004233,45.1549874 Z",
    id: "Path",
    fill: "#A9AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1558345,43.3478963 C46.3627837,34.8710408 38.5313455,28.765041 29.3017874,28.765041 L20.1934121,28.765041 C29.4229702,28.765041 37.2541426,34.8710408 40.0474592,43.3478963 C40.3395204,44.2343169 39.7064997,45.1549874 38.792048,45.1549874 L47.9004233,45.1549874 C48.8151408,45.1549874 49.4481614,44.2345887 49.1558345,43.3478963 Z",
    id: "Path",
    fill: "#8F95BE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.035559, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8127804,13.2938623 C27.7362439,13.288154 27.6620991,13.286523 27.5887517,13.2870667 L27.5887517,12.33867 C27.5887517,5.64471321 22.2832838,0.218003467 15.7388813,0.218003467 C9.19447887,0.218003467 3.88901104,5.64444138 3.88901104,12.33867 L3.88901104,13.2930468 C3.76463922,13.2843484 3.63548387,13.2835329 3.50021623,13.2938623 C1.56766954,13.4395604 0.0733474816,14.5583911 0.24209984,16.9034234 C0.407928929,19.2071384 2.11724415,21.8351402 4.00939658,21.7892019 C4.82472293,27.6701308 9.76425061,32.1935668 15.7386156,32.1935668 C21.7140436,32.1935668 26.6541028,27.6687717 27.4683661,21.7864836 C29.2938148,21.6815592 30.9095855,19.1397258 31.0703653,16.9034234 C31.2396491,14.5581193 29.7453271,13.4392885 27.8127804,13.2938623 Z",
    id: "Path",
    fill: "#A9AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8127804,13.2938623 C27.7362439,13.288154 27.6620991,13.286523 27.5887517,13.2870667 L27.5887517,12.33867 C27.5887517,5.83308777 22.577471,0.525709108 16.2879244,0.232138355 C20.6156916,2.66551371 23.5498566,7.37161598 23.5498566,12.7798416 L23.5498566,16.1352466 C23.5498566,24.022786 17.3105372,30.4188229 9.60506532,30.4441026 C11.3941061,31.554235 13.4935449,32.1935668 15.7391471,32.1935668 C21.7145751,32.1935668 26.6546343,27.6687717 27.4688976,21.7864836 C29.2943463,21.6815592 30.910117,19.1397258 31.0708968,16.9034234 C31.2396491,14.5581193 29.7453271,13.4392885 27.8127804,13.2938623 L27.8127804,13.2938623 Z",
    id: "Path",
    fill: "#8F95BE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.972552, 13.047589)",
    fill: "#192783"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.37985451,10.7215845 C5.38120708,11.4383864 6.59967883,11.8591711 7.91488422,11.8591711 C9.22982385,11.8591711 10.4485614,11.4383864 11.4499139,10.7215845 C12.1209371,10.2412701 11.762438,9.15369918 10.9433911,9.15369918 L4.88664309,9.15369918 C4.06733046,9.15369918 3.70883135,10.2412701 4.37985451,10.7215845 L4.37985451,10.7215845 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    transform: "translate(2.783427, 2.842091) rotate(-67.485887) translate(-2.783427, -2.842091) ",
    cx: 2.78342664,
    cy: 2.84209108,
    rx: 1.99460434,
    ry: 1.96300771
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    transform: "translate(13.085032, 2.840773) rotate(-67.485887) translate(-13.085032, -2.840773) ",
    cx: 13.0850315,
    cy: 2.84077327,
    rx: 1.99460434,
    ry: 1.96300771
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M111.319968,57.5 L78.3291548,57.5 C74.0682147,57.5 70.6140351,54.1126778 70.6140351,49.9342105 C70.6140351,45.7557432 74.0682147,42.3684211 78.3291548,42.3684211 L111.319968,42.3684211 C115.580908,42.3684211 119.035088,45.7557432 119.035088,49.9342105 C119.035088,54.1126778 115.580908,57.5 111.319968,57.5 Z",
    id: "Path",
    fill: "#CDCFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.319968,81.7105263 L78.3291548,81.7105263 C74.0682147,81.7105263 70.6140351,78.3232041 70.6140351,74.1447368 C70.6140351,69.9662696 74.0682147,66.5789474 78.3291548,66.5789474 L111.319968,66.5789474 C115.580908,66.5789474 119.035088,69.9662696 119.035088,74.1447368 C119.035088,78.3232041 115.580908,81.7105263 111.319968,81.7105263 Z",
    id: "Path",
    fill: "#CDCFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.739477,43.377193 C115.794258,43.734653 115.823276,44.1002134 115.823276,44.4725676 C115.823276,48.5851871 112.363118,51.9191291 108.094804,51.9191291 L75.0468958,51.9191291 C73.8170334,51.9191291 72.6549694,51.6411046 71.622807,51.1485518 C72.1727874,54.7417046 75.3853453,57.5 79.2674799,57.5 L112.315388,57.5 C116.583702,57.5 120.04386,54.166058 120.04386,50.0534385 C120.04386,47.1255586 118.28978,44.5938113 115.739477,43.377193 L115.739477,43.377193 Z",
    id: "Path",
    fill: "#A9AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.739477,67.5877193 C115.794258,67.9451793 115.823276,68.3107397 115.823276,68.6830939 C115.823276,72.7957134 112.363118,76.1296554 108.094804,76.1296554 L75.0468958,76.1296554 C73.8170334,76.1296554 72.6549694,75.8516309 71.622807,75.3590782 C72.1727874,78.9522309 75.3853453,81.7105263 79.2674799,81.7105263 L112.315388,81.7105263 C116.583702,81.7105263 120.04386,78.3765844 120.04386,74.2639648 C120.04386,71.3360849 118.28978,68.8043377 115.739477,67.5877193 L115.739477,67.5877193 Z",
    id: "Path",
    fill: "#A9AED0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(85.745614, 76.666667)",
    fill: "#F9C23A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7677083,21.6023077 L21.6423611,27.7704895 L31.6007755,37.7985431 C32.1206713,38.3220746 32.963206,38.3220746 33.4831019,37.7985431 L37.7261227,33.5258508 C38.2457523,33.0025874 38.2457523,32.1538928 37.7261227,31.6303613 L27.7677083,21.6023077 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.897037,29.7884848 L33.4831019,32.2193007 C32.963206,32.7428322 32.1206713,32.7428322 31.6007755,32.2193007 L24.4127431,24.9810023 L21.6423611,27.7704895 L31.6007755,37.7985431 C32.1206713,38.3220746 32.963206,38.3220746 33.4831019,37.7985431 L37.7261227,33.5258508 C38.2460185,33.0023193 38.2460185,32.1538928 37.7261227,31.6303613 L35.897037,29.7884848 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0484375,0.147703963 L37.2237963,13.3303497 C37.9505324,13.602704 38.1536458,14.5412005 37.6052662,15.0934149 L15.178669,37.6768415 C14.6302894,38.2290559 13.6983102,38.0245221 13.4278472,37.292704 L0.336747685,1.87136364 C-0.0606944444,0.795885781 0.980428241,-0.252517483 2.0484375,0.147703963 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2237963,13.3303497 L32.6416319,11.6131235 L17.6564931,26.7030536 C17.1081134,27.2552681 16.1761343,27.0507343 15.9056713,26.3189161 L6.90612269,1.9681352 L2.0487037,0.147703963 C0.980694444,-0.252517483 -0.0604282407,0.795885781 0.337013889,1.87136364 L13.4281134,37.292704 C13.6985764,38.0245221 14.6305556,38.2290559 15.1789352,37.6768415 L37.6055324,15.0934149 C38.1536458,14.5412005 37.9505324,13.602704 37.2237963,13.3303497 L37.2237963,13.3303497 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "orders/static/media/login.3831ee5979e3f90e1fd0ceafbfbd9760.svg";
export { ForwardRef as ReactComponent };